module.exports = __webpack_public_path__ + "img/telegram.a6372f27.svg";